/* Enhance Seal's existing login controls; Seal remains responsible for authentication. */
(() => {
  'use strict';
  const enhance = () => {
    const root = document.querySelector('.seal-login-form');
    if (!root || root.dataset.pwEnhanced) return false;
    const input = root.querySelector('input[name="customer_email"]');
    const trigger = root.querySelector('[data-action="send_customer_portal_login_link"]');
    if (!input || !trigger) return false;
    root.dataset.pwEnhanced = 'true';
    if (input) {
      if (!input.id) input.id = 'pw-seal-customer-email';
      const label = root.querySelector('.seal-floating-label label');
      if (label) label.htmlFor = input.id;
      input.type = 'email';
      input.autocomplete = 'email';
      input.inputMode = 'email';
      input.spellcheck = false;
    }
    if (trigger && trigger.tagName !== 'BUTTON') {
      trigger.setAttribute('role', 'button');
      trigger.tabIndex = 0;
      trigger.addEventListener('keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        if (trigger.getAttribute('aria-disabled') !== 'true' && !trigger.classList.contains('seal-disabled')) trigger.click();
      });
    }
    root.querySelector('[data-seal-customer-portal-error]')?.setAttribute('role', 'alert');
    root.querySelector('[data-seal-customer-portal-success]')?.setAttribute('role', 'status');
    // Seal returns a neutral result: never infer whether this address has a subscription.
    const copyNode = document.getElementById('pw-seal-login-copy');
    if (copyNode) {
      try {
        const settings = JSON.parse(copyNode.textContent);
        const language = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
        const lang = language === 'no' ? 'nb' : language;
        const copy = settings.locales[lang] || settings.locales.en;
        const form = root.querySelector('[data-seal-form]');
        if (form && copy) {
          const notice = document.createElement('section');
          notice.className = 'pw-seal-subscribe-notice';
          const title = document.createElement('h3');
          title.id = 'pw-seal-subscribe-title';
          title.textContent = copy.title;
          notice.setAttribute('aria-labelledby', title.id);
          const description = document.createElement('p');
          description.textContent = copy.text;
          const link = document.createElement('a');
          link.className = 'pw-seal-subscribe-link';
          link.textContent = copy.cta;
          // Shopify's locale root preserves the customer's language and current domain.
          link.href = settings.root.replace(/\/?$/, '/') + '#scent-club';
          notice.append(title, description, link);
          form.append(notice);
          const success = root.querySelector('[data-seal-customer-portal-success]');
          if (success) {
            const updateMessage = () => {
              if (success.textContent.trim() && success.textContent !== copy.success) {
                success.textContent = copy.success;
              }
            };
            updateMessage();
            new MutationObserver(updateMessage).observe(success, { childList: true, characterData: true, subtree: true });
          }
        }
      } catch (error) {
        // Keep Seal's original login usable if optional presentation data is unavailable.
      }
    }

    return true;
  };
  if (!enhance()) {
    const observer = new MutationObserver(() => { if (enhance()) observer.disconnect(); });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 10000);
  }
})();
